document.addEventListener("DOMContentLoaded", function () {
// Allow both the button and the anchor to toggle
document.querySelectorAll(".toggle-submenu, .toggle-submenu-link").forEach(function (trigger) {
  trigger.addEventListener("click", function (e) {
    // prevent anchor navigation / page jump
    if (this.matches("a")) e.preventDefault();

    const item = this.closest(".menu-item");
    if (!item) return;

    // the submenu is a direct child of the li
    const submenu = item.querySelector(":scope > .submenu");
    if (!submenu) return; // nothing to toggle for items without submenu

    // the arrow button (if present)
    const arrowBtn = item.querySelector(":scope > .toggle-submenu") || this;

    const isOpen = submenu.style.maxHeight && submenu.style.maxHeight !== "0px";

    // Close all other submenus
    document.querySelectorAll(".submenu").forEach(function (el) {
      if (el !== submenu) {
        el.style.maxHeight = null;
        el.style.margin = "0";
        const otherBtn = el.parentElement.querySelector(":scope > .toggle-submenu");
        if (otherBtn) {
          otherBtn.classList.remove("active");
          otherBtn.innerHTML = '<img class="down_arr" src="https://softbrush.co.il/cdn/shop/files/arrow-down-3101.png?v=1750564925" alt="arrow">';
        }
      }
    });

    // Toggle current submenu
    if (!isOpen) {
      submenu.style.maxHeight = submenu.scrollHeight + "px";
      submenu.style.margin = "0 0 15px 0";
      arrowBtn.classList.add("active");
      arrowBtn.innerHTML = '<img class="up_arr" src="https://softbrush.co.il/cdn/shop/files/arrow-down-3101.png?v=1750564925" alt="arrow">';
    } else {
      submenu.style.maxHeight = null;
      submenu.style.margin = "0";
      arrowBtn.classList.remove("active");
      arrowBtn.innerHTML = '<img class="down_arr" src="https://softbrush.co.il/cdn/shop/files/arrow-down-3101.png?v=1750564925" alt="arrow">';
    }
  });
});


});



document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 767) {
    const blocks = document.querySelectorAll(".footer__block");

    blocks.forEach(block => {
      const title = block.querySelector(".bold");
      if (title) {
        title.addEventListener("click", () => {
          // Close all other blocks
          blocks.forEach(b => {
            if (b !== block) {
              b.classList.remove("active");
            }
          });

          // Toggle the clicked block
          block.classList.toggle("active");
        });
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const qty = document.querySelector('div[data-block-type="quantity-selector"]');
  const atc = document.querySelector('div[data-block-type="buy-buttons"]');

  if (qty && atc && qty.parentElement === atc.parentElement) {
    const wrapper = document.createElement("div");
    wrapper.id = "qty_atc_wrapper";

    // Insert wrapper before qty
    qty.parentElement.insertBefore(wrapper, qty);

    // Move qty and atc into wrapper
    wrapper.appendChild(qty);
    wrapper.appendChild(atc);
  }
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".collection_atc").forEach(function (btn) {
    btn.addEventListener("click", function () {
      // Find the closest product-card
      const productCard = btn.closest("product-card");

      if (productCard) {
        // Look inside this product card for the quick-buy form
        const submitBtn = productCard.querySelector('.product-card__quick-buy button[type="submit"]');
        if (submitBtn) {
          submitBtn.click();
        }
      }
    });
  });
});


